import { axios } from '~/common/utils/request'
const commonPath = 'rest/erp/general/v3/'

// API列表
export const getApiList = params => axios({
  url: `${commonPath}apiapplicationform/query`,
  method: 'post',
  data: params
})

// API详情
export const getApiDetail = id => axios({
  url: `${commonPath}apiapplicationform/${id}`,
  method: 'get'
})

// API编辑
export const editApi = params => axios({
  url: `${commonPath}apiapplicationform/updatehttpmethod`,
  method: 'patch',
  data: params
})

// API审批
export const approveApi = params => axios({
  url: `${commonPath}apiapplicationform/approve`,
  method: 'patch',
  data: params
})

// API分派：批量修改管理商户和成员
export const dispatchApi = params => axios({
  url: `${commonPath}apiapplicationform/dispatch`,
  method: 'patch',
  data: params
})

// API归档/恢复：批量修改激活字段
export const archiveApi = params => axios({
  url: `${commonPath}apiapplicationform/archive`,
  method: 'patch',
  data: params
})

// API暂停
export const suspendApi = id => axios({
  url: `${commonPath}apiapplicationform/suspend/${id}`,
  method: 'patch'
})

// API启动
export const enableApi = id => axios({
  url: `${commonPath}apiapplicationform/enable/${id}`,
  method: 'patch'
})

// 接口出参
export const interfaceOutField = params => axios({
  url: `${commonPath}service_interface/field/list`,
  method: 'post',
  data: params
})

// 接口入参
export const interfaceInField = params => axios({
  url: `${commonPath}service_interface/in/field/list`,
  method: 'post',
  data: params
})

// 接口入参映射
export const interfaceFieldCode = () => axios({
  url: `${commonPath}entity_field_code/avab`,
  method: 'get'
})

// 请求头添加
export const addHttpHeader = params => axios({
  url: `${commonPath}apiapplicationform/httpheader/create`,
  method: 'post',
  data: params
})

// 请求头编辑
export const editHttpHeader = params => axios({
  url: `${commonPath}apiapplicationform/httpheader/update`,
  method: 'put',
  data: params
})

// 请求头删除
export const delHttpHeader = params => axios({
  url: `${commonPath}apiapplicationform/httpheader/delete`,
  method: 'delete',
  data: params
})

// 更新联系人节点
export const updateContractPath = params => axios({
  url: `${commonPath}apiapplicationform/updateordercontactspath`,
  method: 'patch',
  data: params
})

// 更新联系人对方栏目子节点
export const updateContractColumnPath = params => axios({
  url: `${commonPath}apiapplicationform/updatecontactparammapyoupath`,
  method: 'patch',
  data: params
})

// 更新联系人对方栏目值子节点
export const updateContractColumnYouPath = params => axios({
  url: `${commonPath}apiapplicationform/updatecontactparammapyouvaluepath`,
  method: 'patch',
  data: params
})

// 更新对方入参节点
export const updateInParamYouPath = params => axios({
  url: `${commonPath}apiapplicationform/updateinparammapyoupath`,
  method: 'patch',
  data: params
})

// 更新出参节点
export const updateOutParamPath = params => axios({
  url: `${commonPath}apiapplicationform/updateoutparampath`,
  method: 'patch',
  data: params
})

// 更新对方出参节点
export const updateOutParamYouPath = params => axios({
  url: `${commonPath}apiapplicationform/updateoutparammapyoupath`,
  method: 'patch',
  data: params
})

// 爬虫任务列表
export const getCrawlerTaskList = params => axios({
  url: 'api/match-admin/v1/crawler-task/query',
  method: 'post',
  data: params
})

// 接出访问日志列表
export const getOutAccessLogList = params => axios({
  url: 'api/general-admin/v1/out-access-log/list',
  method: 'post',
  data: params
})
